var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D7F3DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4746 18.6797L13.8896 22.2646H22.8519V18.6797H17.4746Z",
    fill: "#16A02C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8405 10.7842L6.7207 18.904V22.2648H10.0816L18.2014 14.145L14.8405 10.7842ZM9.33768 20.4724H8.51316V19.6479L14.8405 13.3205L15.665 14.145L9.33768 20.4724Z",
    fill: "#16A02C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8007 11.5456C21.1503 11.196 21.1503 10.6314 20.8007 10.2819L18.7036 8.18471C18.5243 8.00547 18.3003 7.9248 18.0673 7.9248C17.8432 7.9248 17.6102 8.01443 17.4399 8.18471L15.7998 9.8248L19.1607 13.1857L20.8007 11.5456Z",
    fill: "#16A02C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRound);
export default __webpack_public_path__ + "static/media/edit_round.04e7c973d653d209014876b32aa1934c.svg";
export { ForwardRef as ReactComponent };